export default __webpack_public_path__ + "static/media/purplegradientbg.0b4ad53e.svg";